/**
 * Deep links out to the systems a contract lives in. Match the Employee Portal
 * exactly — these ids appear in support threads, so the URL a reviewer lands on
 * has to be the same one anyone else would paste.
 *
 * Lives outside RecordDrawer because reconciliation's signed-contract review
 * needs the same links, and two copies of the HubSpot portal id is one too many.
 */

/** The Cinch HubSpot portal. Baked in — we have exactly one. */
const HUBSPOT_PORTAL_ID = "21771408";

export const hubspotDealUrl = (id: string) =>
  `https://app.hubspot.com/contacts/${HUBSPOT_PORTAL_ID}/record/0-3/${id}`;

export const stripeCustomerUrl = (id: string) =>
  `https://dashboard.stripe.com/customers/${id}`;

export const pandadocUrl = (id: string) =>
  `https://app.pandadoc.com/a/#/documents/${id}`;

export const qboCustomerUrl = (id: string | number) =>
  `https://qbo.intuit.com/app/customerdetail?nameId=${id}`;
